module.exports = __webpack_public_path__ + "img/ezgif.com-apng-maker-5.080bfb8b.png";